export type SalonjobsInterviewVideoLike = {
  category?: string | null;
  id?: string | number | null;
};

export type SalonjobsInterviewNavItem = {
  href: string;
};

function isRegisteredInterviewVideo(video: SalonjobsInterviewVideoLike): boolean {
  if (video.category !== "interview") return false;
  if (video.id == null) return false;
  return String(video.id).trim() !== "";
}

/** Interview videos that are actually registered (category + non-empty id). */
export function salonjobsInterviewVideos<T extends SalonjobsInterviewVideoLike>(
  videos: T[] | null | undefined,
): T[] {
  return (videos ?? []).filter(isRegisteredInterviewVideo);
}

export function salonjobsHasRegisteredInterviewVideo(
  videos: SalonjobsInterviewVideoLike[] | null | undefined,
): boolean {
  return salonjobsInterviewVideos(videos).length > 0;
}

/** Drop the #interview contents chip when no interview video is registered. */
export function salonjobsContentNavForInterview<T extends SalonjobsInterviewNavItem>(
  contentNav: T[] | null | undefined,
  hasInterviewVideo: boolean,
): T[] {
  const items = contentNav ?? [];
  if (hasInterviewVideo) return items;
  return items.filter((item) => item.href !== "#interview");
}
